var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5" },
              [
                _c("c-multi-select", {
                  attrs: {
                    codeGroupCd: "REGULATION_BILL_API_CD",
                    codeAttrVal2: "Y",
                    itemText: "codeName",
                    itemValue: "code",
                    label: "관련 법규",
                    name: "regulationBillCds",
                  },
                  on: { datachange: _vm.billCdChange },
                  model: {
                    value: _vm.searchParam.regulationBillCds,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "regulationBillCds", $$v)
                    },
                    expression: "searchParam.regulationBillCds",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7" },
              [
                _c("c-multi-select", {
                  attrs: {
                    type: "search",
                    comboItems: _vm.regulatedItems,
                    itemText: "regulatedItemName",
                    itemValue: "regulatedItemCd",
                    label: "규제 법규",
                    name: "regulatedItemCds",
                  },
                  model: {
                    value: _vm.searchParam.regulatedItemCds,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "regulatedItemCds", $$v)
                    },
                    expression: "searchParam.regulatedItemCds",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "규제별 담당자 목록",
            columns: _vm.grid.columns,
            data: _vm.grid.data,
            merge: _vm.grid.merge,
            checkClickFlag: false,
          },
          scopedSlots: _vm._u([
            {
              key: "customArea",
              fn: function ({ props, col }) {
                return [
                  col.name === "users"
                    ? [
                        _c("c-tag", {
                          attrs: {
                            editable: _vm.editable,
                            icon: "person_outline",
                            itemText: "userName",
                            itemValue: "check",
                            name: "users",
                          },
                          on: {
                            addTag: function ($event) {
                              return _vm.addManager(props.row)
                            },
                            removeTag: (item) => _vm.removeManager(item),
                          },
                          model: {
                            value: props.row.users,
                            callback: function ($$v) {
                              _vm.$set(props.row, "users", $$v)
                            },
                            expression: "props.row.users",
                          },
                        }),
                      ]
                    : _vm._e(),
                ]
              },
            },
          ]),
        },
        [
          _c("template", { slot: "table-button" }, [
            _c(
              "div",
              [
                _c(
                  "q-btn-group",
                  { attrs: { outline: "" } },
                  [
                    _c("c-btn", {
                      attrs: { label: "검색", icon: "search" },
                      on: { btnClicked: _vm.getList },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }